import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import API from '../../services/API';

import Button from '../Button';
import ModalWrapper from '../ModalWrapper';

import qmStyles from '../../theme/qmStyles';
import Icon from '../../scenes/Auth/components/Icon';
import QmImage from '../Image/QmImage';
import Loader from '../Loader';

import ownStyles from './LaunchAreaNotificationModal.scss';

const LaunchAreaNotificationModal = ({ isOpen, closeModal, payload }) => {
  const [loading, setLoading] = useState(true);
  const [isRepeat, setIsRepeat] = useState(false);

  useEffect(
    () => {
      if (isOpen) {
        setLoading(true);
        API.SignupService()
          .joinWaitlist(payload)
          .then(({ data }) => {
            if (data.requested_count > 1) {
              setIsRepeat(true);
            }
          })
          .catch(error => {
            closeModal();
            throw error;
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
    [isOpen],
  );

  return (
    <ModalWrapper
      isOpen={isOpen}
      closeModal={closeModal}
      additionalClassName={ownStyles.modalContainer}
    >
      {({ closeModal }) =>
        isOpen ? (
          <div className="flex-1 flex-col p-double-gutter text-center">
            <Button
              className="self-end"
              borderColor="transparent"
              style={{ width: 'unset' }}
              text={<Icon icon="close" className="text-20" />}
              onClick={closeModal}
            />
            {loading ? (
              <Loader />
            ) : (
              <div className="flex-1 flex-col justify-between">
                <RequestResponse isRepeat={isRepeat} payload={payload} />
                <Button
                  backgroundColor={qmStyles.qmBabyGreen}
                  textColor={qmStyles.white}
                  text="Done"
                  className="self-end p-gutter p-horizontal-double-gutter"
                  style={{ width: 'unset' }}
                  onClick={closeModal}
                />
              </div>
            )}
          </div>
        ) : null
      }
    </ModalWrapper>
  );
};

LaunchAreaNotificationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  payload: PropTypes.object.isRequired,
};

export default LaunchAreaNotificationModal;

const RequestResponse = ({ isRepeat, payload }) => (
  <div className="flex-col items-center">
    {isRepeat ? (
      <React.Fragment>
        <QmImage
          src="static/ui/requested-high-five.png"
          height={115}
          width={100}
        />
        <span className="text-20 font-bold">Already Requested!!</span>
        <span className="mb-gutter">
          Looks like you’ve already requested to be notified when we’re in your
          area.
        </span>
        <span className="color-grey-medium font-medium">
          Excited to get your community started?
        </span>
        <span>Reach out to our team to learn more at</span>
        <a className="color-green" href="mailto:Community@quartermaster.house">
          Community@quartermaster.house
        </a>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <QmImage src="static/ui/art_todo_reward.png" height={100} width={256} />
        <span className="text-20 font-bold">Success!</span>
        <span>
          We'll notify {payload.email} when {payload.address} is in our service
          area!
        </span>
      </React.Fragment>
    )}
  </div>
);

RequestResponse.propTypes = {
  isRepeat: PropTypes.bool.isRequired,
  payload: PropTypes.object.isRequired,
};
